const requiredInputSelectValidator = (
  message = 'validators.requiredValidator'
) => ({
  validate: ({ value = '', title = '' } = {}) => {
    return !title && !value ? message : true;
  }
});

export default requiredInputSelectValidator;
